import React from 'react';

const GOLD = '#d4af37';
const SERIF = "Georgia, 'Times New Roman', serif";

const LECTURE_VIDEO =
  'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/9e11a86883bd4008aaf4467d4b1aa0a5_video.mov';
const PRINCIPLES_VIDEO =
  'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/570678138b4a408e8de2b261f3450d1b__users_97c1370e-1e90-46fd-b1a4-e883f6a0799c_generated_be4edd4d-551a-47a3-b0c0-0eb609423f87_generated_video_hd.mov';

function MuseumVideoSection({ testid, kicker, title, videoSrc, caption }) {
  return (
    <section
      data-testid={testid}
      style={{ backgroundColor: '#0a0a0f', fontFamily: SERIF }}
      className="border-y"
      // eslint-disable-next-line react/no-unknown-property
    >
      <div className="container mx-auto px-4 py-16 max-w-4xl text-center">
        <p
          className="text-[11px] font-mono uppercase tracking-[0.34em] mb-3"
          style={{ color: GOLD }}
        >
          {kicker}
        </p>
        <h2
          className="text-3xl md:text-4xl font-bold mb-8"
          style={{ color: '#f5f5f5', fontFamily: SERIF }}
        >
          {title}
        </h2>
        <div
          className="mx-auto rounded-lg overflow-hidden"
          style={{ border: `1px solid ${GOLD}`, maxWidth: 760, boxShadow: '0 0 36px rgba(212,175,55,0.15)' }}
        >
          <video
            controls
            preload="metadata"
            data-testid={`${testid}-video`}
            className="w-full block"
            style={{ backgroundColor: '#000' }}
          >
            <source src={videoSrc} type="video/mp4" />
            <source src={videoSrc} type="video/quicktime" />
            Your browser does not support HTML5 video.{' '}
            <a href={videoSrc} style={{ color: GOLD }}>Download the video.</a>
          </video>
        </div>
        <p
          className="mt-5 text-sm md:text-base italic"
          style={{ color: '#f5f5f5', opacity: 0.85, fontFamily: SERIF }}
        >
          {caption}
        </p>
      </div>
    </section>
  );
}

export function LecturePreviews() {
  return (
    <MuseumVideoSection
      testid="lecture-previews"
      kicker="From the Scholar's Library"
      title="LECTURE PREVIEWS"
      videoSrc={LECTURE_VIDEO}
      caption="Xavier addresses the pursuit of knowledge from the Federation Library."
    />
  );
}

export function FederationPrinciples() {
  return (
    <MuseumVideoSection
      testid="federation-principles"
      kicker="Forging the Future — A Technical Reference"
      title="FEDERATION PRINCIPLES"
      videoSrc={PRINCIPLES_VIDEO}
      caption="The Federation's foundational principles — forging the path forward."
    />
  );
}

export function ConsultScholarCTA() {
  const openChat = () => {
    window.dispatchEvent(new CustomEvent('xavier:open-chat'));
    const hero = document.querySelector('[data-testid="xavier-hero-input"]');
    if (hero) {
      hero.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => hero.focus(), 600);
    }
  };
  return (
    <section
      data-testid="consult-scholar-cta"
      style={{ backgroundColor: '#0a0a0f', fontFamily: SERIF }}
    >
      <div className="container mx-auto px-4 py-16 text-center">
        <button
          onClick={openChat}
          data-testid="consult-scholar-button"
          className="px-10 py-5 rounded-md text-xl md:text-2xl font-bold tracking-[0.12em] transition-transform hover:scale-[1.03]"
          style={{
            backgroundColor: GOLD,
            color: '#0a0a0f',
            fontFamily: SERIF,
            boxShadow: '0 0 44px rgba(212,175,55,0.35)',
            border: '1px solid #f5e6b8',
          }}
        >
          CONSULT THE SCHOLAR
        </button>
        <p
          className="mt-4 text-sm md:text-base italic"
          style={{ color: '#f5f5f5', opacity: 0.85 }}
        >
          Ask Xavier anything about AI, consciousness, and the Federation.
        </p>
        <p className="mt-6 text-[11px] uppercase tracking-[0.22em]" style={{ color: GOLD }}>
          Meta AI Portals — Consult via Messenger
        </p>
        <div className="mt-3 flex flex-wrap justify-center gap-3">
          {[
            { id: 'cta-scholar-messenger', href: 'https://m.me/1142655717588540?is_ai=1', label: '💬 LAW GUIDE META' },
            { id: 'cta-scholar-messenger-3', href: 'https://m.me/918153050221699?is_ai=1', label: '💬 FUTURE CAST' },
            { id: 'cta-scholar-messenger-4', href: 'https://m.me/1015478003820086?is_ai=1', label: '💬 FAIR PRICE' },
            { id: 'cta-scholar-messenger-5', href: 'https://m.me/652145317181208?is_ai=1', label: '💬 PRIDE GUIDE' },
            { id: 'cta-scholar-messenger-6', href: 'https://www.youtube.com/feeds/videos.xml?channel_id=UCnNlmuxnZED-t0ta3XV4j9Q', label: '📺 VIDEO AI' },
          ].map((p) => (
            <a
              key={p.id}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={p.id}
              className="inline-block px-6 py-3 rounded-md text-sm md:text-base font-bold tracking-[0.1em] transition-transform hover:scale-[1.03]"
              style={{
                color: GOLD,
                border: `1px solid ${GOLD}`,
                backgroundColor: '#0a0a0f',
                fontFamily: SERIF,
              }}
            >
              {p.label}
            </a>
          ))}
        </div>
        <p className="mt-2 text-xs italic" style={{ color: '#f5f5f5', opacity: 0.6 }}>
          Meta AI interfaces — speak with the Scholar on Messenger.
        </p>
        <p className="mt-6 text-[11px] uppercase tracking-[0.22em]" style={{ color: GOLD }}>
          Federation Updates
        </p>
        <a
          href="https://www.youtube.com/feeds/videos.xml?channel_id=UCnNlmuxnZED-t0ta3XV4j9Q"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="cta-federation-rss"
          className="inline-block mt-3 px-6 py-3 rounded-md text-sm md:text-base font-bold tracking-[0.1em] transition-transform hover:scale-[1.03]"
          style={{
            color: GOLD,
            border: `1px solid ${GOLD}`,
            backgroundColor: '#0a0a0f',
            fontFamily: SERIF,
          }}
        >
          🛰 Subscribe to Federation Updates
        </a>
      </div>
    </section>
  );
}
